module.exports = __webpack_public_path__ + "img/Time.f8b76dcb.svg";